import { render, staticRenderFns } from "./CornerNotification.vue?vue&type=template&id=ca630068&scoped=true&"
import script from "./CornerNotification.vue?vue&type=script&lang=js&"
export * from "./CornerNotification.vue?vue&type=script&lang=js&"
import style0 from "./CornerNotification.vue?vue&type=style&index=0&id=ca630068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca630068",
  null
  
)

export default component.exports